var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg54(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6344 35.872C7.91803 35.5101 8.30802 35.299 8.72165 35.299H46.2318C46.9173 35.299 47.26 36.3545 46.7755 36.9727L39.3656 46.427C39.082 46.7889 38.692 47 38.2784 47H0.768169C0.0827276 47 -0.259993 45.9445 0.224543 45.3263L7.6344 35.872Z",
    fill: "url(#paint0_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6344 0.572987C7.92985 0.2111 8.31984 0 8.72165 0H46.2318C46.9173 0 47.26 1.0555 46.7755 1.67372L39.3656 11.128C39.082 11.4899 38.692 11.701 38.2784 11.701H0.768169C0.0827276 11.701 -0.259993 10.6455 0.224543 10.0273L7.6344 0.572987Z",
    fill: "url(#paint1_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3656 18.1094C39.082 17.7475 38.692 17.5364 38.2784 17.5364H0.768169C0.0827276 17.5364 -0.259993 18.5919 0.224543 19.2101L7.6344 28.6644C7.91803 29.0263 8.30802 29.2374 8.72165 29.2374H46.2318C46.9173 29.2374 47.26 28.1819 46.7755 27.5637L39.3656 18.1094Z",
    fill: "url(#paint2_linear_1_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 42.6485,
    y1: -5.64774,
    x2: 5.39739,
    y2: 50.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2",
    x1: 31.2974,
    y1: -13.2091,
    x2: -5.95374,
    y2: 42.7127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 36.9368,
    y1: -9.45247,
    x2: -0.314309,
    y2: 46.4693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg54);
export default __webpack_public_path__ + "static/media/54.98d0f36eb14cc663434530082c7e0261.svg";
export { ForwardRef as ReactComponent };